var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.617
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.73a7.408 7.408 0 01-2.119.582A3.712 3.712 0 0017.504.27a7.439 7.439 0 01-2.346.9 3.692 3.692 0 00-6.386 2.523 3.736 3.736 0 00.088.839A10.568 10.568 0 011.254.588 4 4 0 00.76 2.53a3.687 3.687 0 001.643 3.072 3.793 3.793 0 01-1.671-.551v.134a3.694 3.694 0 002.96 3.619 3.683 3.683 0 01-.973.13 3.556 3.556 0 01-.694-.158 3.778 3.778 0 003.446 2.653 7.408 7.408 0 01-4.59 1.577 7.755 7.755 0 01-.881-.11 10.428 10.428 0 0016.166-8.781l-.011-.477A7.381 7.381 0 0018 1.73z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/twitter_full.348653a1b7005300ef0fa8efaa507920.svg";
export { SvgTwitterFull as ReactComponent };